import { useState } from "react";

// Shows the video's thumbnail with a play button and only swaps in the real
// YouTube player once it's clicked. Each YouTube iframe downloads the full
// player (roughly 0.5-1 MB of scripts) whether or not anyone presses play, and
// the homepage has 11 of them, so loading them all up front was a large part
// of the site's slow first load.
//
// The preview is YouTube's full-HD thumbnail (maxresdefault, 1280x720). Videos
// uploaded below HD don't have one: YouTube then returns a 120x90 gray
// placeholder instead of an error, so a 120px-wide result means "missing" and
// we fall back to hqdefault (480x360), which exists for every video.
const LiteYouTube = ({ videoId, className = "", width, height, title = "YouTube video player" }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [thumb, setThumb] = useState("maxresdefault");
  const style = width && height ? { width, height } : undefined;

  if (isPlaying) {
    return (
      <iframe
        className={className}
        style={style}
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setIsPlaying(true)}
      aria-label={`Play video: ${title}`}
      className={`group relative block bg-black overflow-hidden ${className}`}
      style={style}
    >
      <img
        src={`https://i.ytimg.com/vi/${videoId}/${thumb}.jpg`}
        onLoad={(e) => {
          if (thumb === "maxresdefault" && e.currentTarget.naturalWidth <= 120) {
            setThumb("hqdefault");
          }
        }}
        alt=""
        className="w-full h-full object-cover"
      />
      <span className="absolute inset-0 flex items-center justify-center">
        <svg viewBox="0 0 68 48" className="w-16 h-12 opacity-90 group-hover:opacity-100 transition-opacity" aria-hidden="true">
          <path d="M66.5 7.7a8.5 8.5 0 0 0-6-6C55.2.3 34 .3 34 .3s-21.2 0-26.5 1.4a8.5 8.5 0 0 0-6 6C.1 13 .1 24 .1 24s0 11 1.4 16.3a8.5 8.5 0 0 0 6 6C12.8 47.7 34 47.7 34 47.7s21.2 0 26.5-1.4a8.5 8.5 0 0 0 6-6C67.9 35 67.9 24 67.9 24s0-11-1.4-16.3z" fill="#f00" />
          <path d="M45 24 27 14v20z" fill="#fff" />
        </svg>
      </span>
    </button>
  );
};

export default LiteYouTube;
